exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2pTStv-XHEtDc0rb0Foiow{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center}html[dir=ltr] ._2pTStv-XHEtDc0rb0Foiow{margin-left:auto}html[dir=rtl] ._2pTStv-XHEtDc0rb0Foiow{margin-right:auto}._vZ0JbidqipHs_QmB1JXT{font-size:14px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._vZ0JbidqipHs_QmB1JXT{margin-left:5px}html[dir=rtl] ._vZ0JbidqipHs_QmB1JXT{margin-right:5px}", ""]);

// exports
exports.locals = {
	"iconWell": "_2pTStv-XHEtDc0rb0Foiow",
	"icon": "_vZ0JbidqipHs_QmB1JXT"
};